import React from "react";
import I18n from "i18n-js";

import HealthSection from "./HealthSection";

import selfReportedMetricsIcon from "../../assets/icons/self-reported-team-metrics.svg";

import confidenceLevelIcon from "../../assets/images/onboarding/confidence-level.svg";
import resourcesIcon from "../../assets/images/onboarding/resources.svg";
import clarityOfGoalsIcon from "../../assets/images/onboarding/clarity-of-goals.svg";

const getKPIs = (team, confidenceLevel, resources, clarityOfGoals) => [
  {
    title: I18n.t("dashboard.self_reported_team_metrics.confidence_level.title"),
    score: confidenceLevel?.score,
    indicator: confidenceLevel?.indicator,
    message: confidenceLevel?.message,
    icon: confidenceLevelIcon,
    updateLink: team ? `/confidence_levels/confirm_answer?team_uuid=${team.uuid}` : null,
    about: I18n.t("dashboard.self_reported_team_metrics.confidence_level.about")
  },
  {
    title: I18n.t("dashboard.self_reported_team_metrics.resources.title"),
    score: resources?.score,
    indicator: resources?.indicator,
    message: resources?.message,
    icon: resourcesIcon,
    updateLink: team ? `/resources/confirm_answer?team_uuid=${team.uuid}` : null,
    about: I18n.t("dashboard.self_reported_team_metrics.resources.about")
  },
  {
    title: I18n.t("dashboard.self_reported_team_metrics.clarity_of_goals.title"),
    score: clarityOfGoals?.score,
    indicator: clarityOfGoals?.indicator,
    message: clarityOfGoals?.message,
    icon: clarityOfGoalsIcon,
    updateLink: team ? `/clarity_goals_roles/confirm_answer?team_uuid=${team.uuid}` : null,
    about: I18n.t("dashboard.self_reported_team_metrics.clarity_of_goals.about")
  }
];

const SelfReportedTeamMetrics = ({ team, confidenceLevel, resources, clarityOfGoals, ofuscate }) => {
  return (
    <div className="self-reported-team-metrics-section">
      <HealthSection
        icon={selfReportedMetricsIcon}
        title={I18n.t("dashboard.self_reported_team_metrics.title")}
        kpis={getKPIs(team, confidenceLevel, resources, clarityOfGoals)}
        ofuscate={ofuscate}
      />
    </div>
  );
}

export default SelfReportedTeamMetrics;
